export const commonTranslations = {
    en: {
        // Actions
        action: "Action",
        add: "Add",
        edit: "Edit",
        delete: "Delete",
        view: "View",
        save: "Save",
        cancel: "Cancel",
        submit: "Submit",
        reset: "Reset",
        close: "Close",
        back: "Back",
        next: "Next",
        previous: "Previous",
        search: "Search",
        filter: "Filter",
        export: "Export",
        import: "Import",
        download: "Download",
        upload: "Upload",
        refresh: "Refresh",

        // Status
        active: "Active",
        inactive: "Inactive",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        completed: "Completed",
        cancelled: "Cancelled",

        // Messages
        loading: "Loading...",
        saving: "Saving...",
        translating: "Translating...",
        success: "Success",
        error: "Error",
        warning: "Warning",
        info: "Information",
        noDataFound: "No data found",
        noRecordsFound: "No records found",

        // Common fields
        srNo: "Sr. No.",
        name: "Name",
        email: "Email",
        phone: "Phone",
        address: "Address",
        city: "City",
        state: "State",
        pincode: "Pincode",
        date: "Date",
        time: "Time",
        status: "Status",
        description: "Description",
        remarks: "Remarks",
        createdAt: "Created At",
        updatedAt: "Updated At",
        createdBy: "Created By",
        updatedBy: "Updated By",

        // Navigation
        dashboard: "Dashboard",
        home: "Home",
        profile: "Profile",
        settings: "Settings",
        logout: "Logout",

        // Pagination
        rowsPerPage: "Rows per page",
        page: "Page",
        of: "of",

        // Validation
        required: "This field is required",
        invalidEmail: "Invalid email address",
        invalidPhone: "Invalid phone number",

        // Other
        unknown: "Unknown",
        notAvailable: "N/A",
        yes: "Yes",
        no: "No",
        male: "Male",
        female: "Female",
        other: "Other",
        all: "All",
        total: "Total",
        viewProfile: "View Profile",
    },
    mr: {
        // Actions
        action: "कृती",
        add: "जोडा",
        edit: "संपादित करा",
        delete: "हटवा",
        view: "पहा",
        save: "जतन करा",
        cancel: "रद्द करा",
        submit: "सबमिट करा",
        reset: "रीसेट करा",
        close: "बंद करा",
        back: "मागे",
        next: "पुढे",
        previous: "मागील",
        search: "शोध",
        filter: "फिल्टर",
        export: "निर्यात करा",
        import: "आयात करा",
        download: "डाउनलोड करा",
        upload: "अपलोड करा",
        refresh: "रिफ्रेश करा",

        // Status
        active: "सक्रिय",
        inactive: "निष्क्रिय",
        pending: "प्रलंबित",
        approved: "मंजूर",
        rejected: "नाकारले",
        completed: "पूर्ण झाले",
        cancelled: "रद्द केले",

        // Messages
        loading: "लोड करत आहे...",
        saving: "जतन करत आहे...",
        translating: "भाषांतर करत आहे...",
        success: "यशस्वी",
        error: "त्रुटी",
        warning: "इशारा",
        info: "माहिती",
        noDataFound: "डेटा आढळला नाही",
        noRecordsFound: "रेकॉर्ड आढळले नाहीत",

        // Common fields
        srNo: "अ.क्र.",
        name: "नाव",
        email: "ईमेल",
        phone: "फोन",
        address: "पत्ता",
        city: "शहर",
        state: "राज्य",
        pincode: "पिनकोड",
        date: "तारीख",
        time: "वेळ",
        status: "स्थिती",
        description: "वर्णन",
        remarks: "टिप्पण्या",
        createdAt: "निर्मिती तारीख",
        updatedAt: "अद्यतन तारीख",
        createdBy: "निर्मिती केली",
        updatedBy: "अद्यतन केले",

        // Navigation
        dashboard: "डॅशबोर्ड",
        home: "मुख्यपृष्ठ",
        profile: "प्रोफाइल",
        settings: "सेटिंग्ज",
        logout: "लॉगआउट",

        // Pagination
        rowsPerPage: "प्रति पृष्ठ पंक्ती",
        page: "पृष्ठ",
        of: "च्या",

        // Validation
        required: "हे फील्ड आवश्यक आहे",
        invalidEmail: "अवैध ईमेल पत्ता",
        invalidPhone: "अवैध फोन नंबर",

        // Other
        unknown: "अज्ञात",
        notAvailable: "उपलब्ध नाही",
        yes: "होय",
        no: "नाही",
        male: "पुरुष",
        female: "महिला",
        other: "इतर",
        all: "सर्व",
        total: "एकूण",
        viewProfile: "प्रोफाइल पहा",
    }
};
